import { LockClosedIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Textarea } from '@/shared/ui/atoms';

export interface CommentFieldProps {
  /** Texto do comentário da correção */
  readonly value: string;
  /** Comentário somente-leitura após aplicar a devolutiva da IA */
  readonly isLocked: boolean;
  /** Altera o texto do comentário */
  readonly onChange: (next: string) => void;
}

/**
 * Campo de comentário da correção.
 *
 * Fica somente-leitura enquanto guarda a devolutiva gerada pela IA — alterar a
 * completude o destrava.
 */
export function CommentField({ value, isLocked, onChange }: CommentFieldProps) {
  const { t } = useTranslation('examCorrection');

  return (
    <div className="flex flex-col gap-nano">
      <label
        htmlFor="correction-comment"
        className="flex items-center gap-quark text-ctx-content-title ts-subtitle-xs"
      >
        {t('modal.fields.comment')}
        {isLocked && (
          <LockClosedIcon className="size-xxxs text-ctx-content-placeholder" aria-hidden="true" />
        )}
      </label>
      <Textarea
        id="correction-comment"
        placeholder={t('modal.fields.commentPlaceholder')}
        value={value}
        onChange={e => onChange(e.target.value)}
        readOnly={isLocked}
        {...(isLocked ? { 'aria-describedby': 'correction-comment-locked' } : {})}
        rows={6}
      />
      {isLocked && (
        <span
          id="correction-comment-locked"
          className="text-ctx-content-placeholder ts-caption-xxs"
        >
          {t('modal.fields.commentLocked')}
        </span>
      )}
    </div>
  );
}
